/**
      *********************************************************
      Description: Textbox component. .
      Required props:  type,value.
      limitations    : N/A.
      *********************************************************
**/

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React, { useEffect, useState, Fragment } from "react";
import DefaultSettings from './settings';
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import { getEnvVariable } from '../../../modules/environmentalList';
import { Typography } from '@material-ui/core';

export default function TextBox(props) {
    const { value, handleFieldValue, multiline, extraProps, rowsMax, shareProps, error, required, tooltip, contexthelp, className, disabled, changefieldto, FieldIsSpellCheck, ...otherProps } = props
    const { label, helperText, name, xtype, fullWidth, inputProps, ...otherConfigs } = otherProps;

    const [currentVal, setCurrentVal] = useState(value)

    useEffect(() => {
        setCurrentVal(value)
        if (error && currentVal !== value) {
            handleFieldValue({ target: { value: value, name: name, checked: false }, currentTarget: { dataset: null } })
        }
    }, [value])

    let tlabel = <Typography variant={value || disabled ? 'h6' : 'caption'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
        {tooltip && <Tooltip title={tooltip ? tooltip : null}
            placement="bottom-start" >
            <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        </Tooltip>}
    </Typography>
    return (
        <Box className={className}>
            {/* <FormControl   > */}
            {/* <InputLabel style={{ fontWeight: 'bold', color: error ? 'red' : 'black' }} shrink>{label}{tooltip && <Tooltip title={tooltip ? tooltip : null}
                    placement="bottom-start" ><HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: getEnvVariable('ModuleKey') == 'AEPS' ? "#00355f" : '#007bff', marginLeft: 5 }} onClick={(evt) => contexthelp ?
                        DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
                </Tooltip>}</InputLabel> */}
            {/* <div className='pt-'></div> */}
            <TextField
                disabled={disabled || false}
                //required={required}
                error={error}
                fullWidth={fullWidth ? fullWidth : true}
                label={tlabel}
                //   className='pt-2'
                InputProps={{
                    inputProps: { ...inputProps, style: { fontWeight: 500 } }
                }}
                multiline={multiline || (changefieldto === 'TA' ? true : false)}
                maxRows={rowsMax || 3}
                value={currentVal}
                type={xtype || 'text'}
                onChange={(evt) => { setCurrentVal(evt.target.value) }}
                onBlur={() => {
                    handleFieldValue({ target: { value: currentVal, name: name, checked: false }, currentTarget: { dataset: null } })
                }}
                InputLabelProps={{
                    shrink: (currentVal || disabled) ? true : false,
                }}
                name={name}
                helperText={helperText}
                {...otherConfigs}
                {...extraProps}

                spellcheck={FieldIsSpellCheck === 'Y' ? true : false}
            />
            {/* </FormControl> */}
        </Box>
    )
}